import React from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { ExperienceStart } from '@confluence/experience-tracker/entry-points/component.ts';
import { SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';

import { SHARE_BUTTON_PAGE_SEGMENT_LOAD } from './perf.config.ts';
import {
	ShareRestrictAndCopyCoordinator,
	type ShareRestrictAndCopyCoordinatorProps as ShareAndRestrictButtonProps,
} from './shareAndRestrictButton/ShareRestrictAndCopyCoordinator.tsx';

export const ShareAndRestrictButton = (
	props: Omit<ShareAndRestrictButtonProps, 'flags'>,
): React.JSX.Element => (
	<>
		<PageSegmentLoadStart
			metric={SHARE_BUTTON_PAGE_SEGMENT_LOAD}
			isCustomStart
			key={props.contentId}
		/>
		<ExperienceStart name={SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE} />
		<ShareRestrictAndCopyCoordinator {...props} />
	</>
);
